import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import supportFemaleImage from "../../../files/support-user-female.png";
import supportMaleImage from "../../../files/support-user-male.png";
import Swal from 'sweetalert2';
import { useFetch2 } from "components/utils/authenticatedHook";
import ReactLoading from "react-loading";
import LottieLoader from '../../LottieLoader';
import lottieEmptyFile from '../../../files/animation/empty_new.json';
import lottieLoaderFile from '../../../files/animation/loading.json';
import SupportUserResetPasswordModal from "./SupportUserResetPassword";
import encryptRequest from "../../../helpers/encryptationHelper";
import { UncontrolledTooltip } from 'reactstrap';
const _ = require("lodash");

function fullname(cell, row) {
  const userImage = row.gender == "Female" ? supportFemaleImage : supportMaleImage;
  const profile = row.profileImage || userImage;
  return (
    <div className={row.isActive ? "" : " text-danger"}>
      <span>
        <img src={profile} className="mr-2" alt="image"   
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = userImage;
        }}/>
        {capitalize(row.fname)}
        {", "}
        {capitalize(row.lname)}
        
      </span>
    </div>
  );
}
function capitalize(cell) {
  if (cell) {
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }
}

function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}
const SupportUsersList = (props, context) => {
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2(null);
  const [{ response : resetPasswordResponse, error : resetPasswordError, isLoading:resetPasswordLoading }, doFetch2] = useFetch2(null);
  const [isSubmit, setSubmit] = useState(false);
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if(!isLoading && isSubmit){
      setSubmit(false);
      props.getSupportUsers(true)
    }
  }, [isLoading])

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {"   "}Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "25",
        value: 25
      },
      {
        text: "50",
        value: 50
      },
      {
        text: "All",
        value: props.supportUsers.length
      }
    ] // A numeric array is also available. the purpose of above example is custom the text
  };

  const handleResetPassword = (user) => {
    setSelectedUser(user);
    setResetModalOpen(true);
  };

  function deactivate(cell, row) {
    const name = row.fname + " " + row.lname;
    return (
      <div className="d-flex gap-2">
        {/* Activate/Deactivate Button */}
        {row.isActive ? (
        <>
          <button
            id={`deactivate-${row._id}`}
            type="button"
            className="btn btn-sm me-2 mr-1"
            style={{ borderRadius: "8px", background: '#0da5cd' }}
            onClick={() => {
              Swal.fire({
                title: 'Are you sure you want to deactivate this support user?',
                text: "Once deactivated, they will no longer be able to log in to the admin portal.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Deactivate it!',
              }).then((result) => {
                if (result.isConfirmed) {
                  setSubmit(true);
                  doFetch({
                    url: "/support-action/" + row._id + "?enable=false",
                    method: "PUT",
                  });
                }
              });
            }}
          >
            <i className="mdi mdi-account-remove"  style={{ fontSize: "15px", color: 'white' }}></i>
          </button>
         <UncontrolledTooltip
            target={`deactivate-${row._id}`}
            placement="top"
          >
            Deactivate Account of {name}
         </UncontrolledTooltip>
        </>
        ) : (
          <>
          <button
            type="button"
            id={`activate-${row._id}`}
            className="btn btn-sm me-2 mr-1"
            style={{ borderRadius: "8px", background: "#f76927" }}
            onClick={() => {
              Swal.fire({
                title: 'Are you sure you want to reactivate this support user?',
                text: 'Once reactivated, they will be able to access the admin portal again.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Activate it!',
              }).then((result) => {
                if (result.isConfirmed) {
                  setSubmit(true);
                  doFetch({
                    url: "/support-action/" + row._id + "?enable=true",
                    method: "PUT",
                  });
                }
              });
            }}
          >
            <i className="mdi mdi-account-check" style={{ fontSize: "15px", color: 'white' }}></i>
          </button>
          <UncontrolledTooltip
            target={`activate-${row._id}`}
            placement="top"
          >
            Activate Account of {name}
          </UncontrolledTooltip>
          </>
        )}

        {/* Edit Button */}
        <>
        <button
          type="button"
          title="Edit User"
          className="btn btn-sm me-2 mr-1"
          style={{ borderRadius: "8px", background: '#4caf50' }}
          onClick={() => props.handleEdit(row)}
          id={`edit-${row._id}`}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: "15px", color: 'white' }}></i>
        </button>
        <UncontrolledTooltip
          target={`edit-${row._id}`}
          placement="top"
        >
          Edit Account of {name}
        </UncontrolledTooltip>
        </>
       
        {/* Delete Button */}
        <>
        <button
          type="button"
          title="Delete User"
          className="btn btn-sm mr-1"
          id={`delete-${row._id}`}
          style={{ borderRadius: "8px", background: '#d33' }}
          onClick={() => {
            Swal.fire({
              title: 'Are you sure you want to delete this support user?',
              text: "This action cannot be undone.",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, Delete it!',
            }).then((result) => {
              if (result.isConfirmed) {
                doFetch({
                  url: "/support-action/" + row._id,
                  method: "DELETE",
                });
                setSubmit(true);
              }
            });
          }}
        >
          <i className="mdi mdi-delete" style={{ fontSize: "15px", color: 'white' }}></i>
        </button>
        <UncontrolledTooltip
          target={`delete-${row._id}`}
          placement="top"
        >
          Delete Account of {name}
        </UncontrolledTooltip>
        </>

        {/* Reset Password Button */}
        <>
        <button
          type="button"
          className="btn btn-sm"
          title="Reset Password"
          style={{ borderRadius: "8px", background: '#ff9800' }}
          onClick={() => handleResetPassword(row)}
          id={`reset-${row._id}`}
        >
          <i className="mdi mdi-lock-reset" style={{ fontSize: "15px", color: 'white' }}></i>
        </button>
         <UncontrolledTooltip
          target={`reset-${row._id}`}
          placement="top"
        >
          Reset password of {name}
        </UncontrolledTooltip>
        </>
      </div>
    );
  }

  const handlePasswordSubmit = (newPassword) => {
    doFetch2({ url: '/reset-password-support-user/' + encryptRequest(selectedUser._id) , method: "PUT", disableWait: true, body: { password: newPassword } });
  };

  const NoDataIndication = () => (
    <div>
      {props.loading && (
        <LottieLoader
          loadLoop={true}
          autoplayLoop={true}
          source={lottieLoaderFile}
          Lheight={150}
          Lwidth={150}
          subTitle={"Please Wait ..."}
        />
      )}
      {!props.loading && (
        <LottieLoader
          loadLoop={false}
          autoplayLoop={true}
          source={lottieEmptyFile}
          Lheight={300}
          Lwidth={300}
          title={"Sorry! No support users found."}
        />
      )}
    </div>
  );
  return (
    <div>
    {isLoading ? (
      <div className="d-flex justify-content-center my-4">
        <ReactLoading type="spin" color="blue" height={50} width={50} />
      </div>
    ) : (
      <BootstrapTable
        wrapperClasses="table-responsive"
        keyField="_id"
        noDataIndication={() => <NoDataIndication />}
        data={props.supportUsers.length ? props.supportUsers : []}
        filter={filterFactory()}
        pagination={paginationFactory(options)}
        columns={[
          {
            dataField: "fname",
            text: "Name",
            formatter: fullname,
            sort: true,
            headerFormatter: priceFormatter
          },
          {
            dataField: "email",
            text: "Email Address",
            sort: true,
            headerFormatter: priceFormatter
          },
          {
            dataField: "username",
            text: "Username",
            sort: true,
            headerFormatter: priceFormatter
          },
          {
            dataField: "phone",
            text: "Phone Number",
            formatter: (cell, row) => (row.phone ? row.phone : "-"),
            headerFormatter: priceFormatter
          },
          {
            dataField: "organization",
            text: "Organization",
            sort: true,
            formatter: (cell, row) => (row.organization ? row.organization : "-"),
            headerFormatter: priceFormatter
          },
          {
            dataField: "isActive",
            text: "Action",
            sort: false,
            formatter: deactivate,
            csvExport: false,
            headerStyle: (colum, colIndex) => {
              return { width: "5%", textAlign: "left" };
            },
          }
        ]}
      />
    )}
    <SupportUserResetPasswordModal
      isOpen={resetModalOpen}
      toggle={() => setResetModalOpen(false)}
      onSubmit={handlePasswordSubmit}
      user={selectedUser}
    />
  </div>
  )  
};

export default SupportUsersList;
